import { Actions, FlexTrackPastDuePeriod } from '../actions/flexTrackToDo';
import { AxiosError } from 'axios';
import {
  FETCH_FLEXTRACK_PAST_DUE_PERIODS_FAILURE,
  FETCH_FLEXTRACK_PAST_DUE_PERIODS_REQUEST,
  FETCH_FLEXTRACK_PAST_DUE_PERIODS_SUCCESS
} from '../constants/flexTrackToDo';
import { DeepReadonly } from 'utility-types';

export type State = DeepReadonly<{
  isFetching: boolean;
  periods: FlexTrackPastDuePeriod[] | null;
  error: AxiosError | null;
}>;

const initialState: State = {
  isFetching: false,
  periods: null,
  error: null
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case FETCH_FLEXTRACK_PAST_DUE_PERIODS_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case FETCH_FLEXTRACK_PAST_DUE_PERIODS_SUCCESS:
      return {
        isFetching: false,
        periods: action.payload,
        error: null
      };
    case FETCH_FLEXTRACK_PAST_DUE_PERIODS_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    default:
      return state;
  }
}
